module.exports = __webpack_public_path__ + "prod/1.42.2/img/distribution-six.c84e2641.png";